export const borderRadius = {
  small: "5px",
  reg: "10px",
  pill: "50px",
}
